import { fetcher } from "matsuri-hooks";
import { getToken as m2mUsers_v1_getToken } from "../../endpoints/m2m-users.v1";
import { LoginResponse } from "./login";

// @see https://github.com/matsuri-tech/m2m-users/blob/master/web/request/login.go#L10-L13
interface GetTokenInput {
  userId: string;
  refreshToken: string;
}
type GetTokenResponse = LoginResponse;
export const requestGetToken = async (input: GetTokenInput) => {
  return await fetcher<GetTokenResponse>(m2mUsers_v1_getToken(), {
    method: "POST",
    body: JSON.stringify(input),
  });
};
